import { createSelector } from '@ngrx/store';

import { getOrderState } from '../order.selector';

export const getOrderCrossSellProgressiveFormState = createSelector(
  getOrderState,
  (state) => state?.orderCrossSellForm?.progressiveForm
);

export const getOrderCrossSellFormState = createSelector(
  getOrderCrossSellProgressiveFormState,
  (state) => state?.formState
);

export const getOrderCrossSellEnabled = createSelector(
  getOrderState,
  (state) => state.orderCrossSellForm.enabled
);

export const getOrderCrossSellProduct = createSelector(
  getOrderState,
  getOrderCrossSellEnabled,
  (state, enabled) => (enabled ? state?.orderCrossSellForm?.product : undefined)
);
